import script from "./BillingHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./BillingHistory.vue?vue&type=script&setup=true&lang=js"

import "./BillingHistory.vue?vue&type=style&index=0&id=2002ce98&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2002ce98"]])

export default __exports__